import { render, staticRenderFns } from "./beds.vue?vue&type=template&id=269f433c&scoped=true&"
import script from "./beds.vue?vue&type=script&lang=js&"
export * from "./beds.vue?vue&type=script&lang=js&"
import style0 from "./beds.vue?vue&type=style&index=0&id=269f433c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269f433c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269f433c')) {
      api.createRecord('269f433c', component.options)
    } else {
      api.reload('269f433c', component.options)
    }
    module.hot.accept("./beds.vue?vue&type=template&id=269f433c&scoped=true&", function () {
      api.rerender('269f433c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/medical/beds/beds.vue"
export default component.exports